/**
 * Single source of truth for connected-app logos (client/public/icons).
 * Used by the node palette, the editor canvas nodes, and the execution graph
 * so an app always renders with the same brand mark everywhere.
 */
export const APP_LOGOS = {
  slack: '/icons/slack.png',
  github: '/icons/github.png',
  linear: '/icons/linear.png',
};

// Logos that are dark/black on transparent — need CSS inversion in dark mode.
// Colored brand marks (e.g. Linear blue) must NOT be listed here.
export const LOGO_NEEDS_ADAPTIVE = new Set([
  '/icons/github.png',
]);

/**
 * Logo URL for a NODE_CATALOG spec if it's an app action/trigger, else null.
 * Integration nodes carry `provider`; per-app triggers carry `triggerProvider`.
 */
export function appLogoForSpec(spec) {
  if (!spec) return null;
  if (spec.logo) return spec.logo; // a node with its own mark, e.g. Trodo Ask
  const provider = spec.provider || spec.triggerProvider;
  return provider ? (APP_LOGOS[provider] || null) : null;
}
